import React from "react";
import { deviceType } from "../feature/core";
import Main from "./Main";
import Side from "./Side";

export default function Split({ ...props }) {
    const leftIllusts = [
        {
            fn: "bg_illust_02",
        },
        {
            fn: "bg_illust_04",
        },
        {
            link: "./assets/bg_timetable_02.png",
            fn: "bg_timetable_02",
        },
        {
            fn: "bg_illust_06",
        },
        {
            fn: "bg_illust_08",
        },
    ];
    const rightIllusts = [
        {
            link: "./assets/bg_timetable_02.png",
            fn: "bg_timetable_01",
        },
        {
            fn: "bg_illust_01",
        },
        {
            fn: "bg_illust_03",
        },
        {
            fn: "bg_illust_05",
        },
        {
            fn: "bg_illust_07",
        },
        {
            link: "./assets/bg_timetable_02.png",
            fn: "bg_timetable_03",
        },
        {
            fn: "bg_illust_09",
        },
    ];

    return (
        <div className={`${props.className} ${deviceType}`}>
            <div className={`${props.className}-content`}>
                <Side
                    side="left"
                    illusts={leftIllusts}
                />
                <Main/>
                <Side
                    side="right"
                    illusts={rightIllusts}
                />
            </div>
        </div>
    );
}
